import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import {
  isMobile,
  isMobileOnly,
  isTablet,
  isBrowser,
} from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import { Swiper, SwiperSlide } from 'swiper/react';

// import Swiper core and required modules
import SwiperCore, {
  Pagination,
  Navigation,
  Autoplay,
  Keyboard,
  EffectFade,
} from 'swiper/core';
import { LargeBusiness } from '../../Constants';

// install Swiper modules
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade, Keyboard]);

function BannerSlide({ slide, renderContent, isSingle}) {
  return (
    <div
      className={
        'row notification-banner-container ' + (isMobileOnly ? 'pt-4 pb-4' : '')
      }
      style={{
        backgroundColor: slide.bgColor,
        color: slide.fgColor,
        height: isSingle ? '46px' : '70px' 
      }}
    >
      <div
        className={
          'container-fluid col-md-12 notification-banner-outer ' +
          (isMobileOnly
            ? 'text-center'
            : slide.desktopIconSize == 'small'
            ? 'text-left p-5'
            : 'text-left p-4')
        }
        style={{
          backgroundSize: slide.iconSize,
          backgroundImage: !isMobileOnly
            ? 'url(' +
              (slide.desktopLeftIcon ? slide.desktopLeftIcon.path : '') +
              '),' +
              'url(' +
              (slide.desktopRightIcon ? slide.desktopRightIcon.path : '') +
              ')'
            : 'url(' + (slide.mobileIcon ? slide.mobileIcon.path : '') + ')',
          backgroundPosition: !isMobileOnly ? 'left,right' : 'top',
        }}
      >
        {slide.text && (
          <div           
            className={`notification-banner-copy ${
                isSingle ? 'single-slide' : ''
              }`}

            style={{
              color: slide.fgColor,
              paddingTop:
                slide.mobileIcon && isMobileOnly ? slide.paddingCopy : '0',
              paddingRight:
                slide.desktopRightIcon && !isMobileOnly
                  ? slide.paddingCopy
                  : '0',
              paddingLeft:
                slide.desktopLeftIcon && !isMobileOnly
                  ? slide.paddingCopy
                  : '0',
            }}
            dangerouslySetInnerHTML={renderContent(slide.text)}
          ></div>
        )}
      </div>
    </div>
  );
}

class EirNotificationBanner extends Component {
  
  constructor(props) {
    super(props);

    this.swiperRef = React.createRef();
    this.playButton = React.createRef();
    this.pauseButton = React.createRef();
    this.userPausedRef = { current: false }; // useRef equivalent
    this.mouseHoverRef = { current: false };
    this.swiperContainerRef = React.createRef();

    this.state = {
      slides: props.bannerSlides.map((content) => ({
        ...content,
        
      accessibleTitle: this.getAccessibleTitle(
          isMobileOnly ? content.textForMobile : content.textForDT
        ),

        bgColor: isMobileOnly ? content.bgColorMobile : content.bgColorDesktop,
        fgColor: isMobileOnly
          ? content.fontColorMobile
          : content.fontColorDesktop,
        text: isMobileOnly ? content.textForMobile : content.textForDT,
        imageAlignment: isMobileOnly ? 'top' : '',
        hideComponent: content.hideComponent,
        iconSize: this.getIconSize(content),
        paddingCopy: this.getPaddingCopy(content),
      })),
    };
  }
  triggerOnResize = () => {
    // on resize of window - toggle classes
    let bgImagePosition = this.state.imageAlignment;
    let bannerCopyElement = document.querySelectorAll(
      '.notification-banner-copy'
    );
    for (var i = 0; i < bannerCopyElement.length; i++) {
      !isMobileOnly && window.innerWidth < 1200
        ? bannerCopyElement[i].classList.add(
            bgImagePosition == 'left'
              ? 'adjust-resize-dtview-left'
              : 'adjust-resize-dtview-right'
          )
        : bannerCopyElement[i].classList.remove(
            'adjust-resize-dtview-left',
            'adjust-resize-dtview-right'
          );
    }
  };
  
 
getAccessibleTitle = (html) => {
  if (!html) {
    return 'Notification update';
  }

  const match = html.match(/title="([^"]+)"/i);
  return match ? match[1] : 'Notification update';
};


  getIconSize = (slide) => {
    switch (isMobileOnly ? slide.mobileIconSize : slide.desktopIconSize) {
      case 'Large':
        return isMobileOnly ? '120px' : '9%';
      case 'Medium':
        return isMobileOnly ? '90px' : '7%';
      default:
        return isMobileOnly ? '60px' : '5%';
    }
  };

  getPaddingCopy = (slide) => {
    switch (isMobileOnly ? slide.mobileIconSize : slide.desktopIconSize) {
      case 'Large':
        return isMobileOnly ? '130px' : '11%';
      case 'Medium':
        return isMobileOnly ? '100px' : '9%';
      default:
        return isMobileOnly ? '70px' : '7%';
    }
  };

 componentDidMount = () => {
  this.triggerOnResize();

  // if (this.swiperRef) {
  //   this.updateSlidesTabIndex(this.swiperRef.swiper);
  // }

  let bannerCopyContainer = document.querySelectorAll(".notification-swiper-container");
  let winComp = window.components;
  let notificationBannerComponents = [];
  
  for (let i = 0; i < winComp.length; i++) {
    if (winComp[i].type === "eir-notification-banner") {
      notificationBannerComponents.push(winComp[i]);
    }
  }

  for (let j = 0; j < bannerCopyContainer.length; j++) {
    let banner = notificationBannerComponents[j];
    let hideComponent = banner.cmsContent.hideComponent.toLowerCase();
    let bannerOccurrence = banner.cmsContent.BannerOccurrence;
    let shouldHideBanner = false;

    if (isMobileOnly && hideComponent === "mobile") {
      shouldHideBanner = true;
    } else if (!isMobileOnly && hideComponent === "desktop") {
      shouldHideBanner = true;
    } else if (hideComponent === "both") {
      shouldHideBanner = true;
    }

    if (bannerOccurrence !== undefined && bannerOccurrence !== null) {
      let index = parseInt(bannerOccurrence);
      if (index !== j) {
        shouldHideBanner = true;
      }
    }

    if (shouldHideBanner) {
      bannerCopyContainer[j].classList.add("hide");
    }
  }

  window.onresize = () => {
    this.triggerOnResize();
  }
}

updateSlidesTabIndex = (swiper) => {
  swiper.slides && swiper.slides.length && swiper.slides.forEach(slideEl => {    
      slideEl.setAttribute('tabindex', '0'); 
      slideEl.setAttribute('aria-hidden', 'false');
  })
};
playPauseToggle = () => {
  // const swiperInstance = this.swiperRef.current?.swiper;
  
 const swiperInstance =
    this.swiperRef &&
    this.swiperRef.current &&
    this.swiperRef.current.swiper;

  if (!swiperInstance) return;

  const playBtn = this.playButton.current;
  const pauseBtn = this.pauseButton.current;

  // If pause button is hidden → autoplay is paused → play
  if (pauseBtn.style.display === 'none') {
    playBtn.style.display = 'none';
    playBtn.tabIndex = -1;

    pauseBtn.style.display = 'flex';
    pauseBtn.tabIndex = 0;

    swiperInstance.autoplay.start();
    this.userPausedRef.current = false;

    if (
      this.mouseHoverRef.current &&
      swiperInstance.autoplay.running
    ) {
      swiperInstance.autoplay.stop();
    }
  }
  // Otherwise → pause
  else {
    pauseBtn.style.display = 'none';
    pauseBtn.tabIndex = -1;

    playBtn.style.display = 'flex';
    playBtn.tabIndex = 0;

    swiperInstance.autoplay.stop();
    this.userPausedRef.current = true;
  }

  this.updateSlidesTabIndex(swiperInstance);
};
handleMouseEnter = () => {
  this.mouseHoverRef.current = true;

  // const swiperInstance = this.swiperRef.current?.swiper;
  const swiperInstance =
  this.swiperRef &&
  this.swiperRef.current &&
  this.swiperRef.current.swiper;

  if (swiperInstance && swiperInstance.autoplay.running) {
    swiperInstance.autoplay.stop(); // pause autoplay on mouse enter
  }
};
handleMouseLeave = () => {
  this.mouseHoverRef.current = false;

  // const swiperInstance = this.swiperRef.current?.swiper;
  const swiperInstance =
  this.swiperRef &&
  this.swiperRef.current &&
  this.swiperRef.current.swiper;

  if (
    swiperInstance &&
    !swiperInstance.autoplay.running &&
    !this.userPausedRef.current
  ) {
    swiperInstance.autoplay.start(); // resume autoplay on mouse leave
  }
};
handleTouchStart = () => {
  this.mouseHoverRef.current = true;

  // const swiperInstance = this.swiperRef.current?.swiper;
  const swiperInstance =
  this.swiperRef &&
  this.swiperRef.current &&
  this.swiperRef.current.swiper;

  if (swiperInstance && swiperInstance.autoplay.running) {
    swiperInstance.autoplay.stop(); // pause autoplay on touch start
  }
};
handleTouchEnd = () => {
  this.mouseHoverRef.current = false;

  // const swiperInstance = this.swiperRef.current?.swiper;
  const swiperInstance =
  this.swiperRef &&
  this.swiperRef.current &&
  this.swiperRef.current.swiper;

  if (
    swiperInstance &&
    !swiperInstance.autoplay.running &&
    !this.userPausedRef.current
  ) {
    swiperInstance.autoplay.start(); // resume autoplay on touch end
  }
};
handleKeyPress = (e) => {
  if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
    e.preventDefault(); // prevent page scroll on space
    this.playPauseToggle();
  }
};

renderContent = (content) => {
    return { __html: content };
  };
render() {
  const {navigator} = this.props;
  const {slides} = this.state;
  const navigationEnabled = slides.length > 1;
  const iconColor = (slides && slides[0] && slides[0].fgColor) || '#F5EBDA';

  return (
    <React.Fragment>
      <div className="notification-swiper-container">        
      <Swiper
  ref={this.swiperRef}
  // loop={navigationEnabled}
  loop={false}
  autoplay={{ delay: navigator.loopInterval }}
  noSwiping={slides.length === 1}
  allowTouchMove={slides.length !== 1} 

onAfterInit={(swiper) => {
      this.updateSlidesTabIndex(swiper);
  }}

  onSlideChange={(swiper) => {
    this.updateSlidesTabIndex(swiper);
  }}

  
pagination={{
  el: '.banner-pagination',
  clickable: true,
  renderBullet: (index, className) => {
    return `<button class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
  },
}}
 
keyboard={{
    enabled: true,
    onlyInViewport: true,
  }}

>
  {slides.map((slide, i) => (
    <SwiperSlide key={i}>
  

      <BannerSlide
        slide={slide}
        renderContent={this.renderContent}
        isSingle={slides.length === 1}
      />
    </SwiperSlide>
  ))}
</Swiper> 
{slides.length > 1 && 
  <div className="notification-ui-layer">      
  <div className="banner-pagination"></div>
  <button
    ref={this.pauseButton}
    className="pause-button"
    aria-label="Pause"
    onClick={this.playPauseToggle}
    onKeyDown={this.handleKeyPress}
    style={{ '--pseudo-active-color': iconColor }}
  >
    <span className="icon pause" aria-hidden="true" />
  </button>

  <button
    ref={this.playButton}
    className="play-button"
    aria-label="Play"
    onClick={this.playPauseToggle}
    onKeyDown={this.handleKeyPress}
    style={{ '--pseudo-active-color': iconColor }}
    tabIndex={-1}
  >
    <span className="icon play" aria-hidden="true" />
  </button>
</div>
}
    </div>
    </React.Fragment>
  );
}




}

export default EirNotificationBanner;
